import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { MODELO_NOTA_FISCAL_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_NOTA_FISCAL_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_NOTA_FISCAL_ENDPOINT,
    id
  ]);
}
